import { Phone, MapPin, Mail, Check } from "lucide-react";

const REGIONS = ["Washington DC", "Maryland", "Virginia"];
const COMPLIANCE = ["HIPAA Compliant", "OSHA 29", "TWIC", "GDP Certified", "BBP Protocols"];

export const Footer = () => (
  <footer data-testid="site-footer" className="relative bg-[#0B1D4F] text-white overflow-hidden">
    <div className="absolute inset-0 bg-grid-light opacity-40" />
    <div className="relative mx-auto max-w-7xl px-5 sm:px-8 pt-20 pb-10">
      <div className="grid md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <a href="#top" data-testid="footer-brand-link" className="inline-flex">
            <img src="/assets/hlm-logo-white.png" alt="HLM Courier" data-testid="footer-logo" className="h-12 w-auto" />
          </a>
          <p className="mt-5 text-sm leading-relaxed text-slate-300 max-w-sm">
            Mission-critical medical courier and specimen logistics — specializing in pharmacy
            delivery, STAT lab specimens, equipment transport, and chemotherapy hazardous drug
            transportation across the DMV.
          </p>
          <div className="mt-6 flex flex-wrap gap-2">
            {COMPLIANCE.map((c) => (
              <span key={c} data-testid={`footer-badge-${c.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                    className="px-3 py-1.5 rounded-lg border border-blue-400/25 bg-white/5 font-mono text-[10px] font-semibold tracking-[0.14em] text-blue-200 uppercase">
                {c}
              </span>
            ))}
          </div>
        </div>

        <div className="md:col-span-4">
          <h3 className="font-mono text-xs font-bold uppercase tracking-[0.22em] text-blue-300">Contact</h3>
          <ul className="mt-5 space-y-4 text-sm">
            <li className="flex items-start gap-3">
              <MapPin className="h-4.5 w-4 h-4 text-blue-300 mt-0.5 shrink-0" />
              <span data-testid="footer-address" className="text-slate-200 leading-relaxed">
                Head Quarters<br />23710 Schooler Plz<br />Ashburn, VA 20148
              </span>
            </li>
            <li>
              <a href="tel:5718509387" data-testid="footer-phone-link"
                 className="flex items-center gap-3 text-slate-200 hover:text-white transition-colors duration-200">
                <Phone className="h-4 w-4 text-blue-300 shrink-0" /> (571) 850-9387
              </a>
            </li>
            <li>
              <a href="mailto:Contact@hlmcourier.com" data-testid="footer-email-link"
                 className="flex items-center gap-3 text-slate-200 hover:text-white transition-colors duration-200">
                <Mail className="h-4 w-4 text-blue-300 shrink-0" /> Contact@hlmcourier.com
              </a>
            </li>
          </ul>
        </div>

        <div className="md:col-span-3">
          <h3 className="font-mono text-xs font-bold uppercase tracking-[0.22em] text-blue-300">Service Region</h3>
          <ul className="mt-5 space-y-3">
            {REGIONS.map((r) => (
              <li key={r} data-testid={`footer-region-${r.toLowerCase().replace(/\s+/g, "-")}`}
                  className="flex items-center gap-2.5 text-sm text-slate-200">
                <span className="h-4.5 w-4.5 h-4 w-4 rounded-full bg-[#0047FF] flex items-center justify-center shrink-0">
                  <Check className="h-2.5 w-2.5 text-white" strokeWidth={4} />
                </span>
                {r}
              </li>
            ))}
          </ul>
          <p className="mt-6 text-xs text-slate-400 leading-relaxed">
            Same-day and STAT courier service available across the entire DMV, 24/7/365.
          </p>
        </div>
      </div>

      <div className="mt-16 pt-7 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
        <p data-testid="footer-copyright" className="text-xs text-slate-400">
          Copyright 2026 HLM Courier. All rights reserved.
        </p>
        <p className="font-mono text-[10px] font-semibold tracking-[0.2em] text-slate-500 uppercase">
          HIPAA · OSHA 29 · TWIC · GDP Certified
        </p>
      </div>
    </div>
  </footer>
);
